import axios from "axios";
import { useEffect, useState } from "react";
import { FaUndo } from "react-icons/fa";
import Swal from "sweetalert2";

function DeleteExternalDesWarehouses ({ setUpdateTrigger, updateTrigger }) {
  const [deletedWarehouses, setDeletedWarehouses] = useState([]);

  const getDeletedWarehouses = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses/delete_list`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        setDeletedWarehouses(response.data.data);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
    }
  }

  const restoreWarehouse = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¿Quieres restaurar este elemento?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, restaurar",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const response = await axios.patch(`${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses/restore/${id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });

        Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
        setUpdateTrigger(!updateTrigger);
        getDeletedWarehouses();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  useEffect(() => {
    getDeletedWarehouses();
  }, [updateTrigger]);

  return (
    <div className='table-responsive'>
      <h3 className="mb-4">Almacenes Eliminados</h3>
      <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Destino</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {deletedWarehouses.map((warehouse) => (
            <tr key={warehouse.id} data-master-id={warehouse.id}>
              <td>{warehouse.name}</td>
              <td>{warehouse.iata_id}</td>
              <td>
                <FaUndo className='restoreButton' onClick={() => { restoreWarehouse(warehouse.id) }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DeleteExternalDesWarehouses;